import { useLocation, Link } from "react-router-dom";
import { regions } from "../data/regions";
import { useLang } from "../i18n/LanguageContext";
import { LogoSeal } from "./Logo";

export const Footer = () => {
  const { pathname } = useLocation();
  const { t } = useLang();
  const pre = pathname === "/" ? "" : "/";
  return (
    <footer data-testid="site-footer" className="relative grain bg-forest text-bone pt-20 pb-10 overflow-hidden">
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16 border-b border-bone/15">
          <div className="md:col-span-4">
            <div className="mb-5">
              <LogoSeal size={72} tone="light" />
            </div>
            <div className="font-serif italic text-4xl md:text-5xl">Fresh Earth</div>
            <p className="mt-6 font-serif text-xl md:text-2xl leading-snug max-w-md text-bone/90">
              {t(
                "Restoring biological activity in waste ecosystems to accelerate landfill recovery and improve urban environmental health.",
                "लैंडफिल रिकवरी को तेज़ करने और शहरी पर्यावरणीय स्वास्थ्य सुधारने हेतु अपशिष्ट परितंत्रों में जैविक सक्रियता की पुनर्स्थापना।"
              )}
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs tracking-[0.18em] uppercase text-bone/50 mb-5">{t("Explore", "अन्वेषण")}</div>
            <ul className="space-y-3">
              <li><a href={`${pre}#solution`} className="text-bone/75 hover:text-terracotta transition-colors duration-300">{t("Solution", "समाधान")}</a></li>
              <li><a href={`${pre}#roi`} className="text-bone/75 hover:text-terracotta transition-colors duration-300">{t("ROI Estimator", "ROI अनुमानक")}</a></li>
              <li><Link to="/case-studies" className="text-bone/75 hover:text-terracotta transition-colors duration-300">{t("Case Studies", "केस स्टडी")}</Link></li>
              <li><Link to="/resources" className="text-bone/75 hover:text-terracotta transition-colors duration-300">{t("Resource Hub", "संसाधन केंद्र")}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs tracking-[0.18em] uppercase text-bone/50 mb-5">{t("Regions", "क्षेत्र")}</div>
            <ul className="space-y-3">
              {regions.map((r) => (
                <li key={r.slug}>
                  <Link to={`/regions/${r.slug}`} className="text-bone/75 hover:text-terracotta transition-colors duration-300">OED · {r.state}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs tracking-[0.18em] uppercase text-bone/50 mb-5">{t("Contact", "संपर्क")}</div>
            <ul className="space-y-3">
              <li><a href="tel:9899534141" className="text-bone/75 hover:text-terracotta transition-colors duration-300">+91 98995 34141</a></li>
              <li><a href="mailto:care@fresh-earth.com" className="text-bone/75 hover:text-terracotta transition-colors duration-300">care@fresh-earth.com</a></li>
              <li className="text-bone/60 text-sm leading-relaxed pt-1">Exotic Buildcon SPV LLP<br />1044P, LGF, Sector 47,<br />Gurugram, Haryana 122018</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs tracking-wide text-bone/50">
          <p>© {new Date().getFullYear()} Fresh Earth · Exotic Buildcon SPV LLP. All rights reserved.</p>
          <p>OED — Odour Eliminator &amp; Decomposer · ISO 14001:2015 · Scalable Biological Waste Remediation</p>
        </div>
      </div>
    </footer>
  );
};
